import React, { useRef, useState } from "react";
import { SiMinutemailer } from "react-icons/si";
import emailjs from "@emailjs/browser";
import { messageValidation } from "./Validation/ValidateContact";
import { useFormik } from "formik";
import { contactAlert } from "./Notification/ContactAlert";

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const form = useRef();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },

    validationSchema: messageValidation,

    onSubmit: (values, { resetForm }) => {},
  });

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_zf3r8x7",
        "template_x6l5kzp",
        form.current,
        "jd5-_cCLamvz6Y3D-"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
    });
    contactAlert();
    formik.resetForm();
  };

  return (
    <div className="flex flex-col justify-center items-center w-full p-4">
      <>
        <form
          ref={form}
          onSubmit={sendEmail}
          className="flex flex-col gap-4 w-full md:w-1/2"
        >
          <div>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              className=" p-3 h-[40px] w-full bg-[#FFFFFF] rounded-md border-2 border-[#343D68] focus:shadow-none focus:outline-none focus:border-2 focus:border-[#E87A5D] focus:bg-white "
              required
            />
            {formik.touched.name && formik.errors.name ? (
              <div>{formik.errors.name}</div>
            ) : null}
          </div>

          <div>
            <input
              type="text"
              id="email"
              name="email"
              placeholder="Enter email address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              className=" p-3 h-[40px] w-full bg-[#FFFFFF] rounded-md border-2 border-[#343D68] focus:shadow-none focus:outline-none focus:border-2 focus:border-[#E87A5D] focus:bg-white "
              required
            />
            {formik.touched.email && formik.errors.email ? (
              <div>{formik.errors.email}</div>
            ) : null}
          </div>

          <div>
            <textarea
              id="message"
              name="message"
              placeholder="write your message"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
              className=" w-full h-[140px] p-3 bg-[#FFFFFF] rounded-md border-2 border-[#343D68] focus:shadow-none focus:outline-none focus:border-2 focus:border-[#E87A5D] focus:bg-white "
              required
            />
            {formik.touched.message && formik.errors.message ? (
              <div>{formik.errors.message}</div>
            ) : null}
          </div>
          <div className="flex justify-center">
            <button
              disabled={isSubmitting}
              type="submit"
              className=" text-white rounded-md bg-[#E84949] w-[180px] h-[40px] flex justify-center items-center gap-2 hover:bg-[#0f0f1e] duration-500"
            >
              {isSubmitting ? "sending" : "Send message"}
              <SiMinutemailer size={20} className="text-[#FFF]" />
            </button>
          </div>
        </form>
      </>
    </div>
  );
};

export default ContactForm;
